import { apiService } from '@/services/APIService';

export default {

  getAllExchanges(params) {
    return apiService.get('/exchanges', params);
  },

  showExchange(id, params) {
    return apiService.get(`/exchanges/${id}`, params);
  },

  getRequestedExchanges(params) {
    return apiService.get('/exchanges/requested', params);
  },

  applyExchange(id, params) {
    return apiService.post(`/exchanges/${id}/apply`, params);
  },

  deleteApply(id) {
    return apiService.delete(`/exchanges/${id}/apply`);
  },

};
